// extracted by mini-css-extract-plugin
module.exports = {"container":"LogoWithMessage_container__f6w1p"};